'use client';

import React from 'react';
import { Mail } from 'lucide-react';

const schools = [
  { name: 'School of Property Practice', colour: 'bg-accent/10 text-accent border-accent/20' },
  { name: 'School of Real Estate', colour: 'bg-primary/10 text-primary border-primary/20' },
  { name: 'School of Property Development', colour: 'bg-primary/10 text-primary border-primary/20' },
  { name: 'School of Property Finance', colour: 'bg-muted-foreground/10 text-muted-foreground border-border' },
  { name: 'School of Cities & Infrastructure', colour: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
];

export default function FacultySection() {
  return (
    <section className="section-pad-lg bg-secondary" id="faculty-section">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10 xl:px-16">
        <div className="max-w-2xl mb-14">
          <div className="flex items-center gap-3 mb-4">
            <div className="divider-gold" />
            <span className="label-caps">Faculty &amp; Programme Leaders</span>
          </div>
          <h2 className="font-serif text-section-title text-foreground">
            Learn From Active
            <br />
            <span className="italic">Industry Practitioners</span>
          </h2>
          <p className="font-sans text-base text-muted-foreground mt-4 leading-relaxed">
            REUSA programmes are led by active real estate practitioners — developers, investment professionals,
            estate agents, and property attorneys who shape the market today. Faculty profiles will be
            published as appointments are confirmed.
          </p>
        </div>

        {/* Schools row */}
        <div className="flex flex-wrap gap-2 mb-12">
          {schools?.map((school) => (
            <span key={school?.name} className={`font-sans text-[0.65rem] font-semibold tracking-wide px-3 py-1.5 rounded-full border ${school?.colour}`}>
              {school?.name}
            </span>
          ))}
        </div>

        {/* Institutional placeholder */}
        <div className="border border-border rounded-2xl bg-card p-12 text-center luxury-shadow">
          <div className="w-16 h-16 rounded-full bg-secondary flex items-center justify-center mx-auto mb-6">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="text-primary">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
          </div>
          <h3 className="font-serif font-semibold text-xl text-foreground mb-3">
            Faculty Profiles Coming Soon
          </h3>
          <p className="font-sans text-sm text-muted-foreground max-w-lg mx-auto leading-relaxed mb-2">
            REUSA is in the process of confirming faculty appointments across all five schools.
            Verified faculty profiles will be published here as appointments are finalised.
          </p>
          <p className="font-sans text-xs text-muted-foreground/60 max-w-md mx-auto leading-relaxed mb-8">
            All faculty members are active industry practitioners. REUSA does not publish unverified profiles.
          </p>
          <a
            href="mailto:admissions@reusa.education?subject=Faculty Directory Enquiry"
            className="btn-outline px-8 py-3.5 rounded-xl font-semibold inline-flex items-center gap-2"
          >
            <Mail size={15} />
            Enquire About Faculty
          </a>
        </div>

        <div className="text-center mt-8">
          <p className="font-sans text-muted-foreground text-xs">
            Programme contributors span property law, construction, urban planning, development finance, and estate agency practice.
          </p>
        </div>
      </div>
    </section>
  );
}